<div class="pg-header">
  <div class="pg-header-top">
    <div>
      <h1>{{ 'pilotagePrevention.header.title' | translate }}</h1>
      <p class="subtitle">{{ 'pilotagePrevention.header.groupSubtitle' | translate }}</p>
    </div>
    <ng-content></ng-content>
  </div>
  <nav class="pg-tabs" [attr.aria-label]="'pilotagePrevention.header.title' | translate">
    <a
      class="pg-tab"
      routerLink="/pilotage-prevention"
      [class.active]="activeTab === 'overview'"
      [attr.aria-current]="activeTab === 'overview' ? 'page' : null">
      {{ 'pilotagePrevention.nav.overview' | translate }}
    </a>
    <a
      class="pg-tab"
      routerLink="/pilotage-prevention/besoins"
      [class.active]="activeTab === 'needs'"
      [attr.aria-current]="activeTab === 'needs' ? 'page' : null">
      {{ 'pilotagePrevention.nav.needsCoverage' | translate }}
    </a>
    <a
      class="pg-tab"
      routerLink="/pilotage-prevention/demande"
      [class.active]="activeTab === 'demand'"
      [attr.aria-current]="activeTab === 'demand' ? 'page' : null">
      {{ 'pilotagePrevention.nav.patientDemand' | translate }}
    </a>
    <a
      class="pg-tab"
      routerLink="/prevention-offres"
      [class.active]="activeTab === 'offers'"
      [attr.aria-current]="activeTab === 'offers' ? 'page' : null">
      {{ 'pilotagePrevention.nav.offersDeployment' | translate }}
    </a>
  </nav>
</div>
